import log from "loglevel";
import { apiCoreEndpoint } from "settings";
import { processServiceResponse } from "lib/request";
import * as t from "./types";

const ABOUT_MICROSERVICE_API_ROOT = `${apiCoreEndpoint}/about/microservice`;

export const getAboutMicroserviceService = async (
  request: t.GetAboutMicroserviceRequestType
): Promise<any> => {
  log.info("getAboutMicroserviceService Request: " + JSON.stringify(request));
  let ENDPOINT = `${ABOUT_MICROSERVICE_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  const response = await fetch(ENDPOINT, parameters);
  const json = processServiceResponse(response, ENDPOINT);
  return json;
};

export const getAboutMicroservicesService = async (
  request?: t.GetAboutMicroservicesRequestType
): Promise<any> => {
  log.info("getAboutMicroservicesService Request: " + JSON.stringify(request));
  const ENDPOINT = ABOUT_MICROSERVICE_API_ROOT;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  const response = await fetch(ENDPOINT, parameters);
  const json = processServiceResponse(response, ENDPOINT);
  return json;
};

export const addAboutMicroserviceService = async (
  request: t.CreateAboutMicroserviceRequestType
): Promise<any> => {
  log.info("addAboutMicroserviceService Request: " + JSON.stringify(request));
  const ENDPOINT = ABOUT_MICROSERVICE_API_ROOT;
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  const response = await fetch(ENDPOINT, parameters);
  const json = processServiceResponse(response, ENDPOINT);
  return json;
};

export const modifyAboutMicroserviceService = async (
  request: t.ModifyAboutMicroserviceRequestType
): Promise<any> => {
  log.info(
    "modifyAboutMicroserviceService Request: " + JSON.stringify(request)
  );
  const ENDPOINT = `${ABOUT_MICROSERVICE_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
    body: JSON.stringify(request.body),
  };

  const response = await fetch(ENDPOINT, parameters);
  const json = processServiceResponse(response, ENDPOINT);
  return json;
};

export const deleteAboutMicroserviceService = async (
  request: t.DeleteAboutMicroserviceRequestType
): Promise<any> => {
  log.info("deleteAboutMicroservice Request: " + JSON.stringify(request));
  const ENDPOINT = `${ABOUT_MICROSERVICE_API_ROOT}/${request.id}/`;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  const response = await fetch(ENDPOINT, parameters);
  const json = processServiceResponse(response, ENDPOINT);
  return json;
};
